$(document).ready(function () {
  console.log('flexible');
    // Slide Flexible
  $('.carousel-w-button .owl-carousel').owlCarousel({
    loop: false,
    rewind: true,
    margin: 2,
    dots: false,
    lazyLoad: true,
    nav: true,
    responsive:{
      0 : {
        items:2
      },
      600 : {
        items:4
      },
      1000 : {
        items:6
      }
    }
  });

  if (window.innerWidth < 768) {
    $('.hero-three-blocks .owl-carousel').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      variableWidth: true,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $('.flexible-hero__slider.owl-carousel').owlCarousel({
    rewind: true,
    lazyLoad: true,
    nav: true,
    items: 1,
    dots: true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    navText: [
      '<i class="far fa-chevron-left"></i>', 
      '<i class="far fa-chevron-right"></i>'
    ]
  });
});
